<template>
  <OriginalTinyMceEditor api-key="m9eo5iq42zwnpyan9hrvdit7s9wo7ih7hzbgkh2m62e6lim4"
                         v-model="content"
                         @input="$emit('input', content)"
                         :init="tinyMceEditorConfig"
                         v-if="shown"></OriginalTinyMceEditor>
</template>

<script>
import OriginalTinyMceEditor from '@tinymce/tinymce-vue';

export default {
  name: 'TinyMceEditor',
  props: {
    value: String,
    customTemplates: Array,
    allowAllStyle: Boolean,
  },
  components: {OriginalTinyMceEditor},
  watch: {
    value(newVal) {
      this.content = newVal;
    },
  },
  data() {
    var v = this;
    return {
      shown: false,

      content: this.value,

      // Email Template
      tinyMceEditorConfig: {
        plugins: 'advlist autoresize code image link lists table template wordcount',
        // toolbar: 'undo redo | fontsizeselect | styleselect | bold italic underline strikethrough |  alignleft aligncenter alignright alignjustify | bullist numlist | link image | indent outdent | template',
        toolbar: 'undo redo | fontsizeselect | styleselect | bold italic underline strikethrough |  alignleft aligncenter alignright alignjustify | bullist numlist | link image | indent outdent',
        // content_css : "/tnc.css",
        // fix_list_elements: false,
        // element_format: 'html',
        // valid_children: '+ol[ol],+li[ol],+li[li],+li[ol]',
        min_height: 320,
        removed_menuitems: 'fontformats',
        image_advtab: true,
        images_upload_base_path: '/static/',
        images_upload_credentials: true,
        images_upload_handler(blobInfo, success, failure) {
          v.$uploadFiles([blobInfo.blob()], function (response) {
            success('/api/static/' + response.body.file_ids[blobInfo.filename()]);
          }, function (response) {
            failure(response.body.msg);
          })
        },
        templates: this.customTemplates ? this.customTemplates : [
          {title: 'User Name (Chinese)', description: '', content: '{{user_name_zh}}'},
          {title: 'User Name (English)', description: '', content: '{{user_name_en}}'},
          {title: 'Url', description: '', content: '{{url}}'},
          {title: 'Event Name (Chinese)', description: '', content: '{{event_name_zh}}'},
          {title: 'Event Name (English)', description: '', content: '{{event_name_en}}'},
          {title: 'Payment Details', description: '', content: '{{payment_detail}}'},
        ],
        image_list: [
          {title: 'QR Code', value: '/api/static/test_qr'},
        ],
        invalid_styles: this.allowAllStyle ? '' : 'font-size font-family line-height background-color background-image color',
      },
    }
  },
  mounted() {
    var v = this;

    setTimeout(() => {
      v.shown = true;
    }, 1000);
  },
}
</script>
